<div class="container-fluid row_banner pb-5">
  <app-header></app-header>
  <div class="container my-5">
    <div
      class="container py-5"
      style="
        background-color: white;
        border-radius: 12px;
        border: 1px solid #e0efed;
        box-shadow: 0px 20px 35px 0px #e2e5ea;
      "
    >
      <div class="row justify-content-center">
        <div class="col">
          <div class="row pdsm">
            <!-- Signup Form -->
            <div class="col-lg-7 col-md-7" *ngIf="showRowBanner">
              <div class="signup-card">
                <h3 class="mb-4">Create an account</h3>
                <p>
                  Enter your details below to create your account and get
                  started.
                </p>

                <div
                  style="height: 15px; margin-top: -14px; margin-bottom: 5px"
                >
                  <p
                    class="text-left"
                    id="eFsubText2"
                    [ngStyle]="{ color: 'red' }"
                    style="font-size: 14px"
                    *ngIf="fieldIf"
                  >
                    <i
                      class="fa fa-times-circle"
                      aria-hidden="true"
                      style="margin-right: 3px"
                    ></i>
                    {{ dangerAlerts }}
                  </p>
                </div>

                <p
                  class="text-left"
                  id="eFsubText2"
                  [ngStyle]="{ color: color }"
                  style="margin-bottom: -3px; margin-top: -20px"
                  *ngIf="emailerror"
                >
                  <!-- <i class="fas fa-check-circle" aria-hidden="true"
                        style="margin-right: 3px;"></i> --><i
                    class="fa fa-times-circle"
                    aria-hidden="true"
                    style="margin-right: 3px"
                  ></i>
                  {{ dangerAlerts2 }}
                </p>
                <form>
                  <div class="form-group">
                    <label for="Your Name" class="">Your Name</label>
                    <input
                      id="firstname"
                      type="text"
                      class="form-control"
                      (keydown.space)="$event.preventDefault()"
                      formControlName="firstname"
                      maxlength="2"
                      maxlength="20"
                      name="firstname"
                      value=""
                      placeholder="Your Name"
                      onfocus="this.placeholder=''"
                      onblur="this.placeholder='Your Name'"
                      (focus)="onFocus()"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="email">Your Email</label>
                    <input
                      id="email"
                      type="email"
                      class="form-control"
                      name="email"
                      formControlName="email"
                      value=""
                      placeholder="Example@email.com"
                      onfocus="this.placeholder=''"
                      onblur="this.placeholder='Example@email.com'"
                      pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}"
                      (focus)="onFocus()"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="password">Password</label>
                    <input
                      id="pass_log_id5"
                      type="password"
                      [type]="passwordFieldType"
                      class="form-control"
                      value=""
                      name="password"
                      formControlName="password"
                      placeholder="At least 8 characters"
                      onfocus="this.placeholder=''"
                      onblur="this.placeholder='At least 8 characters'"
                      (focus)="onFocus()"
                      required
                    />
                    <span
                      toggle="#password-field"
                      class="fa fa-fw fa-eye field_icon toggle-password2 eyeicon float-right"
                      style="margin-top: -25px; margin-right: 10px"
                    ></span>
                  </div>

                  <div class="form-group">
                    <button
                      type="submit"
                      class="btn btn-dark btn-block"
                      style="width: 388pxpx; height: 52pxpx !important"
                      (click)="FormSubmission($event)"
                    >
                      Signup & Proceed to Payment
                    </button>
                  </div>
                </form>
                <div class="or-separator"><span>Or</span></div>
                <button
                  class="btn social-btn w-100 mb-3"
                  (click)="googleLogin()"
                >
                  <img
                    src="../../assets/images/signin-signup/google.svg"
                    alt="Google"
                  /><span>Sign up with Google</span>
                </button>

                <p class="text-center mt-4">
                  Have an account?
                  <a
                    style="cursor: pointer; color: #08ba9c"
                    (click)="showSignIn()"
                  >
                    Sign in</a
                  >
                </p>
              </div>
            </div>

            <!-- signin form  -->
            <div class="col-lg-7 col-md-7" *ngIf="showLeftSection">
              <div class="login-form">
                <h3 style="font-size: 28px; font-weight: 600">Welcome Back!</h3>
                <p style="line-height: 24px">
                  Enter your username or password to continue.
                </p>
                <span
                  class="alert alert-danger mb-2"
                  id="dangerAlert2"
                  style="display: none"
                ></span>
                <span
                  class="alert alert-danger mb-2"
                  id="dangerAlert"
                  style="display: none"
                ></span>
                <form
                  method=""
                  action=""
                  class="mb-0 mt-4"
                  [formGroup]="logins"
                >
                  <div class="form-group">
                    <label for="email" style="font-weight: 600">Email</label>
                    <input
                      id="login_email"
                      name="login_email"
                      ngDefaultControl
                      formControlName="login_email"
                      type="email"
                      class="form-control"
                      name="login_email"
                      value=""
                      placeholder="Example@email.com"
                      onfocus="this.placeholder=''"
                      onblur="this.placeholder='Example@email.com'"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="password" style="font-weight: 600"
                      >Password</label
                    >
                    <input
                      id="login_password"
                      value=""
                      name="login_password"
                      ngDefaultControl
                      formControlName="login_password"
                      type="password"
                      [type]="passwordFieldType"
                      onfocus="this.placeholder=''"
                      onblur="this.placeholder='At least 8 characters'"
                      class="form-control"
                      name="login_password"
                      placeholder="At least 8 characters"
                      required
                    />
                  </div>
                  <span
                    style="
                      color: #000000;
                      float: right;
                      margin-bottom: -30px;
                      padding-left: 20px;
                      margin-top: -45px;
                      margin-right: 20px;
                      cursor: pointer;
                    "
                  >
                    <i
                      class="eye-icon"
                      (click)="togglePasswordVisibility()"
                      [ngClass]="{
                        'fa fa-fw fa-eye': passwordFieldType === 'password',
                        'fas fa-eye-slash': passwordFieldType === 'text'
                      }"
                    ></i>
                  </span>


                  <div class="form-group">
                    <button
                      type="submit"
                      class="btn btn-dark submit btn-block"
                      style="width: 388pxpx; height: 52pxpx !important"
                      (click)="eLogin()"
                    >
                      Sign in
                    </button>
                  </div>
                </form>
                <div class="or-separator"><span>Or</span></div>
                <div class="social-buttons">
                  <button
                    class="btn social-btn w-100 mb-3"
                    (click)="googleLogin()"
                  >
                    <img
                      src="../../assets/images/signin-signup/google.svg"
                      alt="Google"
                    /><span>Sign in with Google</span>
                  </button>
                </div>
                <p class="text-center mt-4">
                  Don't you have an account?
                  <a
                    style="cursor: pointer; color: #08ba9c"
                    (click)="showSignUp()"
                  >
                    Sign up
                  </a>
                </p>
              </div>
            </div>
            <!-- signin form  -->
            <!-- Order Summary -->
            <div class="col-lg-5 col-md-5">
              <div class="border rounded p-3 bg-light">
                <h5 class="mb-3">Your order summary</h5>
                <p class="mb-2"><strong>Grammarin Premium</strong></p>
                <p class="mb-2">1 member</p>
                <p class="mb-2">Billed {{ selectedplan }}</p>
                <hr />
                <!-- <p><strong>Due today:</strong>{{selectedplanamount}} USD</p> -->
                <div class="d-flex justify-content-between">
                  <div>
                    <p><strong>Due today:</strong></p>
                  </div>
                  <div>
                    <p>{{ selectedplanamount }} USD</p>
                  </div>
                </div>
                <!-- <button class="btn w-100 continue-btn">Continue</button> -->
              </div>


                  <div id="recaptcha-container"  data-size="compact" data-theme="light" style="display: flex; justify-content: center;  margin-top: 15px;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>

<div
  class="modal modal-home centered fade bd-example-modal-lg text-center justify-content-center"
  data-backdrop="static"
  data-keyboard="false"
  tabindex="-1"
  role="dialog"
  aria-labelledby="target-btn"
  aria-hidden="true"
>
  <div class="modal-dialog centered modal-lg">
    <div class="modal-content modal-content-homesettaregt">
      <img
        class="modal-content-home-img"
        data-dismiss="modal"
        src="../../assets/images/grammar checker/cross.svg"
        alt="cross-img"
        style="
          cursor: pointer;
          height: 18px;
          width: 18px;
          margin-top: 10px;
          margin-left: 95%;
          float: right;
        "
      />
      <div class="login-form">
        <h3 style="font-size: 28px; font-weight: 600">Welcome Back!</h3>
        <p style="line-height: 24px">
          Enter your username or password to continue.
        </p>
        <span
          class="alert alert-danger mb-2"
          id="dangerAlert2"
          style="display: none"
        ></span>
        <span
          class="alert alert-danger mb-2"
          id="dangerAlert"
          style="display: none"
        ></span>
        <form method="" action="" class="mb-0" [formGroup]="logins">
          <div class="form-group">
            <label for="email" style="font-weight: 600">Email</label>
            <input
              id="login_email"
              name="login_email"
              ngDefaultControl
              formControlName="login_email"
              type="email"
              class="form-control"
              name="login_email"
              value=""
              placeholder="Example@email.com"
              onfocus="this.placeholder=''"
              onblur="this.placeholder='Example@email.com'"
              required
            />
          </div>
          <div class="form-group">
            <label for="password" style="font-weight: 600">Password</label>
            <input
              id="login_password"
              value=""
              name="login_password"
              ngDefaultControl
              formControlName="login_password"
              type="password"
              [type]="passwordFieldType"
              onfocus="this.placeholder=''"
              onblur="this.placeholder='At least 8 characters'"
              class="form-control"
              name="login_password"
              placeholder="At least 8 characters"
              required
            />
          </div>
          <span
            style="
              color: #000000;
              float: right;
              margin-bottom: -30px;
              padding-left: 20px;
              margin-top: -45px;
              margin-right: 20px;
              cursor: pointer;
            "
          >
            <i
              class="eye-icon"
              (click)="togglePasswordVisibility()"
              [ngClass]="{
                'fa fa-fw fa-eye': passwordFieldType === 'password',
                'fas fa-eye-slash': passwordFieldType === 'text'
              }"
            ></i>
          </span>

          <div class="form-group">
            <button
              type="submit"
              class="btn btn-dark submit btn-block"
              style="width: 388pxpx; height: 52pxpx !important"
              (click)="eLogin()"
            >
              Sign in
            </button>
          </div>
        </form>

        <div class="social-buttons"></div>
        <p class="text-center mt-4">
          Don't you have an account?
          <a
            routerLink="/signup"
            (click)="navigateTosignup()"
            style="cursor: pointer; color: #08ba9c"
          >
            Sign up
          </a>
        </p>
      </div>
    </div>
  </div>
</div>

<!-- code for validation  -->
<div
  *ngIf="resendEmail"
  class="backdrop"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  "
></div>

<div
  *ngIf="resendEmail"
  class="content-div"
  style="
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 468px;
    height: 360px;
    background-color: white;
    z-index: 1010;
    border-radius: 4px;
    border: 1px solid white;
  "
>
  <div class="text-center" style="margin-top: 9%">
    <img src="/assets/images/verify-account/Group 38204@2x.svg" />

    <div style="width: 440px; height: 64px; margin-left: 16px">
      <p
        class="error mt-4"
        style="font-size: 24px; font-weight: 500; line-height: 33.89px"
      >
        {{ send }}
      </p>
    </div>

    <button class="mt-2 butn-alert" (click)="closesendDiv()">Ok</button>
  </div>
</div>
<div
  *ngIf="error"
  class="backdrop"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  "
></div>

<div
  *ngIf="error"
  class="content-div"
  style="
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 468px;
    height: 360px;
    background-color: white;
    z-index: 1010;
    border-radius: 4px;
    border: 1px solid white;
  "
>
  <div class="text-center" style="margin-top: 9%">
    <img src="/assets/images/paraphrasing tool/alert.svg" />

    <div style="width: 440px; height: 64px; margin-left: 16px">
      <p
        class="error mt-4"
        style="font-size: 18px; font-weight: 500; line-height: 33.89px"
      >
        {{ errorAlerts }}
      </p>
    </div>

    <button class="mt-4 butn-alert" (click)="closeErrorDiv()">Ok</button>
  </div>
</div>

<div
  *ngIf="success"
  class="backdrop"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  "
></div>

<div
  *ngIf="success"
  class="content-div"
  style="
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 468px;
    height: 360px;
    background-color: white;
    z-index: 1010;
    border-radius: 4px;
    border: 1px solid white;
  "
>
  <div class="text-center" style="margin-top: 9%">
    <img
      src="/assets/images/paraphrasing tool/success.svg"
      style="width: 138px; height: 138px"
    />

    <p
      *ngIf="success"
      class="error mt-4"
      style="font-size: 24px; font-weight: 500; line-height: 33.89px"
    >
      {{ successAlert }}
    </p>

    <!-- <button
    class="mt-4 butn-alert"
    (click)="closeErrorDiv()">Ok</button> -->
  </div>
</div>
<!-- code for validation  -->
